import "../../assets/css/results/wantsView.css"

import { Row, Col, Accordion, Modal, OverlayTrigger, Tooltip } from "react-bootstrap"
import { useEffect, useRef, useState } from "react"

import arrow from "../../assets/images/arrowDown.svg"
import infoIcon from "../../assets/images/infoBlue.svg"
import descriptionIcon from "../../assets/images/description.svg"
import { useGeneralStates } from "../../context/general-context"
import { RESULTS_SECTIONS } from "../../utils/globalUtils"
import { CONNECTIVITY_TRAVEL, getTotalCategoryWeight, GOVERNMENT_LANDSCAPE, HEADER_DESCRIPTION, VAR_BLOCKED } from "./utils.js"
import { useAuth } from "../../context/auth-context.jsx"
import VariableRow from "./variableRow.jsx"
import CategoryRow from "./categoryRow.jsx"
import MobileVariablesTable from "./mobileVariablesTable.jsx"

export default function WantsView() {
    const { state, showSubscribeModal } = useGeneralStates()
    const { user } = useAuth()

    const [activeAccordionItem, setActiveAccordionItem] = useState([])
    const [citiesSelector, setCitiesSelector] = useState({
        min: 0,
        max: 3,
    })
    const [varInfoModal, setVarInfoModal] = useState({
        variable: null,
        show: false
    })
    const [showInfoModal, setShowInfoModal] = useState(null)

    const infoTooltipRefs = useRef({})

    const handleClickOutside = (e) => {
        if (Object.values(infoTooltipRefs.current).every(ref => ref && !ref.contains(e.target))) {
            setShowInfoModal(null);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside)

        return () => {
            document.removeEventListener("click", handleClickOutside)
        }
    }, [])

    function handleInfoModal(variableId) {
        setShowInfoModal(prev => {
            return (
                prev === variableId ? null : variableId
            )
        })
    }
    
    function descriptionTooltip(title) {
        return (
            <Tooltip id="tooltip-img-container">
                {HEADER_DESCRIPTION?.[title]}
            </Tooltip>
        )
    }

    function handleCitiesSelector(direction) {
        if (direction === "min") {
            if (citiesSelector.min === 0) return
            
            setCitiesSelector(prev => {
                return {
                    min: prev.min - 1,
                    max: prev.max - 1
                }
            })
            
            return
        }

        if (citiesSelector.max === user.selectedCities.length) return
        
        setCitiesSelector(prev => {
            return {
                min: prev.min + 1,
                max: prev.max + 1
            }
        })
    }

    function handleAccordionItems(e) {
        const { id } = e.target
        
        if (id === "closeAll" || id === "mobileCloseAll") {
            setActiveAccordionItem([])

            return
        }

        const ids = state?.wantsMatrixReference.map(catRef => catRef._id)
        ids.push(accordionMobileKey)

        setActiveAccordionItem(ids)
    }
    
    function handleAccordionItem(itemId) {
        if (activeAccordionItem.includes(itemId)) {
            setActiveAccordionItem(prev => prev.filter(item => item !== itemId));

            return
        }

        setActiveAccordionItem(prev => [...prev, itemId]);
    }

    function handleShowModal(catId, varId) {
        const category = state.wantsMatrixReference?.find(catRef => catRef._id === catId)
        const variable = category?.variables.find(varRef => varRef._id === varId)

        const variablePoints = ((category?.weight / 100) * variable?.weight)?.toFixed(2)
        variable.points = variablePoints

        setVarInfoModal({
            variable,
            show: true
        })
    }
    
    function handleHideModal() {
        setVarInfoModal(prev => {
            return {
                ...prev,
                show: false,
            }
        })
    }

    function getAccordionHeaderClass(id) {
        return activeAccordionItem.some(item => item === id) ? "activeCategory" : ""
    }

    const selectorCitiesContainerClass = `citiesSelectorContainer ${ user.selectedCities.length <= 3 ? "hide" : ""} d-none d-lg-flex`
    const variableTextClass = user?.selectedCities?.length === 2 ? "withTwo" : user?.selectedCities?.length === 1 ? "withOne" : ""
    
    const wantsViewContainerClass = `wantsViewContainer ${state.resultsSection === RESULTS_SECTIONS.wants ? "move" : ""} ${state.triggerVariableDetails ? "detailsActive" : ""}`

    // mobile consts
    const accordionMobileKey = "mobileTotals"
    const accordionMobileTotalsClass = activeAccordionItem.some(item => item === accordionMobileKey) ? "activeCategory" : ""
    
    return (
        <section className={wantsViewContainerClass}>
            <Row>
                <Col lg={{ span: 10, offset: 1 }} >
                    <div className="wantsTableSection">
                        <div className="tableHeader">
                            <div className="noView"></div>

                            <p className="description">
                                In the city and site selection study, 
                                the rating methodology is based on a scale from 0 to 3, 
                                where 3 represents the best option based on the concept being evaluated. 
                                The other points are assigned based on the difference from the best option
                            </p>
                            
                            <div className="tableActions">
                                <div className="mobile-open-close-container d-lg-none">
                                    <button className="btnBgBlueTextGradient mobile-open-close-button" id="mobileOpenAll" onClick={handleAccordionItems}></button>
                                    <button className="btnBgBlueTextGradient mobile-open-close-button" id="mobileCloseAll" onClick={handleAccordionItems}></button>
                                </div>
                                <span className="d-none d-lg-flex" id="openAll" onClick={handleAccordionItems} >Open all</span>
                                <span className="d-none d-lg-flex" id="closeAll" onClick={handleAccordionItems} >Close all</span>
                                <span id="compareCities" onClick={showSubscribeModal}>Compare cities</span>
                            </div>
                            
                            <div className="headerTable">
                                <div className="headerWithIcon">
                                    <span>Criterion</span>

                                    <OverlayTrigger placement="top" overlay={descriptionTooltip("criterion")}>
                                        <img src={infoIcon} alt="Prodensa Teaser" />
                                    </OverlayTrigger>
                                </div>

                                <div className="headerWithIcon centered">
                                    <span>Points</span>

                                    <OverlayTrigger placement="top" overlay={descriptionTooltip("points")}>
                                        <img src={infoIcon} alt="Prodensa Teaser" />
                                    </OverlayTrigger>
                                </div>
                                <div className="headerWithIcon centered">
                                    <span>Weight%</span>

                                    <OverlayTrigger placement="top" overlay={descriptionTooltip("weight")}>
                                        <img src={infoIcon} alt="Prodensa Teaser" />
                                    </OverlayTrigger>
                                </div>

                                <div className="citiesHeaderContainer d-none d-lg-flex">
                                    {user?.selectedCities?.slice(citiesSelector.min, citiesSelector.max).map(city => {
                                        return (
                                            <span key={`headerTitle-${city.datamexico_municipality_id}`} className={`variableText ${variableTextClass}`}>{city.municipality_name}</span>
                                        )
                                    })}
                                </div>

                                <div className="cities-disclaimer d-none d-lg-block">
                                    <OverlayTrigger placement="top" overlay={descriptionTooltip("weight")}>
                                            <img src={infoIcon} alt="Prodensa Teaser" />
                                    </OverlayTrigger>
                                </div>

                                <div className={selectorCitiesContainerClass}>
                                    <img 
                                        id="leftArrow" 
                                        src={arrow} 
                                        alt="Prodensa Teaser" 
                                        onClick={() => handleCitiesSelector("min")} 
                                    />
                                    <img 
                                        id="rightArrow" 
                                        src={arrow} 
                                        alt="Prodensa Teaser" 
                                        onClick={() => handleCitiesSelector("max")} 
                                    />
                                </div>
                            </div>
                        </div>

                        <Accordion activeKey={activeAccordionItem.map(item => item)}>
                            {state.wantsMatrixReference.sort((a, b) => a.position - b.position).filter(catRefFilter => catRefFilter.weight !== 0).map(catRef => {
                                const sumOfVariablePercentage = catRef.variables.reduce((acc, curr) => {
                                    return acc + curr.weight
                                }, 0)

                                const accordionHeaderClass = getAccordionHeaderClass(catRef._id)

                                const isEveryVarBlocked = catRef.variables.filter(varRef => varRef.weight !== 0).every(varRef => 
                                    VAR_BLOCKED.includes(varRef._id) || varRef._id.toString() === CONNECTIVITY_TRAVEL || varRef._id.toString() === GOVERNMENT_LANDSCAPE
                                )

                                const isTextBlur = isEveryVarBlocked ? "teaserDataHide" : ""
                                
                                return (
                                    <Accordion.Item key={catRef._id} eventKey={catRef._id}>
                                        <Accordion.Header className={accordionHeaderClass} onClick={() => handleAccordionItem(catRef._id)}>
                                            <CategoryRow category={catRef} citiesSelector={citiesSelector} isEveryVarBlocked={isEveryVarBlocked} />
                                        </Accordion.Header>

                                        {/* Accordion Body for Desktop */}
                                        <Accordion.Body className="d-none d-lg-block">
                                            {catRef.variables.sort((a, b) => a.position - b.position).filter(varRefFilter => varRefFilter.weight !== 0).map(varRef => {
                                                const varPoints = ((catRef.weight / 100) * varRef.weight).toFixed(2)
                                                
                                                return (
                                                    <VariableRow 
                                                        key={varRef._id} 
                                                        variable={varRef} 
                                                        varPoints={varPoints}
                                                        showInfoModal={showInfoModal}
                                                        handleInfoModal={handleInfoModal}
                                                        ref={el => (infoTooltipRefs.current[varRef._id] = el)}
                                                    />
                                                ) 
                                            })}

                                            <div className="variableTotal">
                                                <h5 className="pointsText pointsWeight">Points</h5>
                                                <h5 className="totalPoints pointsWeight">{catRef.weight}</h5>
                                                <h5 className="totalPercentage pointsWeight">{`${sumOfVariablePercentage}%`}</h5>
                                                <div className="citiesTotalContainer">
                                                    {user?.selectedCities?.slice(citiesSelector.min, citiesSelector.max).map(city => {
                                                        const cityTotal = user?.result?.filter(varResult => varResult.catRefId === catRef._id)
                                                                            ?.reduce((acc, curr) => {
                                                                                const cityPoints = curr.citiesResults.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)?.points

                                                                                return acc + cityPoints
                                                                            }, 0).toFixed(1)
                                                        return (
                                                            <h5 
                                                                key={`cityTotal-${city.datamexico_municipality_id}`} 
                                                                className={`variableText catCityScore ${variableTextClass} ${isTextBlur}`}
                                                            >
                                                                {/* N/A */}
                                                                {cityTotal}
                                                            </h5>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </Accordion.Body>

                                        {/* Accordion Body for Mobile */}
                                        <Accordion.Body className="d-lg-none">
                                            <MobileVariablesTable 
                                                category={catRef} 
                                                handleShowModal={handleShowModal}
                                                descriptionTooltip={descriptionTooltip}
                                                isTextBlur={isTextBlur}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                )
                            })}

                            {/* Accordion for Mobile Totals */}
                            <Accordion.Item className="d-lg-none" eventKey={accordionMobileKey} >
                                <Accordion.Header className={accordionMobileTotalsClass} onClick={() => handleAccordionItem(accordionMobileKey)} >
                                    <h5 className="greyText">Total</h5>
                                    <h5 className="pointsWeight greyText">{getTotalCategoryWeight(state?.wantsMatrixReference)}</h5>
                                    <h5 className="pointsWeight greyText">{`${getTotalCategoryWeight(state?.wantsMatrixReference)}%`}</h5>
                                </Accordion.Header>

                                <Accordion.Body>
                                    <div className="mobile-total-row mobile-total-header">
                                        <h5>City</h5>
                                        <h5>Points</h5>
                                    </div>

                                    {user && user.selectedCities?.slice(citiesSelector.min, citiesSelector.max).map(city => {
                                        const cityTotal = user?.result?.reduce((acc, curr) => {
                                            const cityPoints = curr?.citiesResults?.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)?.points
                                    
                                            return acc + cityPoints
                                        }, 0).toFixed(2)
                                    
                                        return (
                                            <div 
                                                key={`mobile-cityTotal-${city.datamexico_municipality_id}`} 
                                                className="mobile-total-row"
                                            >
                                                <h5>{city.municipality_name}</h5>
                                                {/* <h5 className="teaserDataHide">N/A</h5> */}
                                                <h5>{cityTotal}</h5>
                                            </div>
                                        )
                                    })}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        <div className="totalsSection d-none d-lg-grid">
                            <h5 id="pointsTextTotal" className=" pointsWeight">Points</h5>
                            <h5 className="percentageTotal pointsWeight">{`${getTotalCategoryWeight(state?.wantsMatrixReference)}%`}</h5>
                            <div className="citiesTotalContainer">
                                {user && user.selectedCities?.slice(citiesSelector.min, citiesSelector.max).map(city => {
                                    const cityTotal = user?.result?.reduce((acc, curr) => {
                                        const cityPoints = curr.citiesResults.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)?.points
                                    
                                        return acc + cityPoints
                                    }, 0).toFixed(1)
                                    
                                    return (
                                        <h5 
                                            key={`cityTotal-${city.datamexico_municipality_id}`} 
                                            className={`pointsWeight variableText catCityScore ${variableTextClass}`}
                                            // className={`pointsWeight variableText catCityScore ${variableTextClass} teaserDataHide`}
                                        >
                                            {/* N/A */}
                                            {cityTotal}
                                        </h5>
                                    )
                                })}
                            </div>
                        </div>

                        <Modal 
                            className="mobile-variable-info-modal"
                            size="md"
                            centered
                            show={varInfoModal?.show}
                            onHide={handleHideModal}
                        >
                            <Modal.Title>
                                {varInfoModal?.variable?.title}
                            </Modal.Title>
                            <Modal.Body>
                                <div className="varInfo-container">
                                    <img src={descriptionIcon} alt="Prodensa Teaser" />
                                    <div className="varData-Container">
                                        <h5>Points</h5>
                                        <span>{varInfoModal?.variable?.points}</span>
                                    </div>
                                </div>
                                <div className="varInfo-container">
                                    <img src={descriptionIcon} alt="Prodensa Teaser" />
                                    <div className="varData-Container">
                                        <h5>Weigth %</h5>
                                        <span>{varInfoModal?.variable?.weight}</span>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </Col>
            </Row>
        </section>
    )
}
